// extracted by mini-css-extract-plugin
export var container = "hero-title-module--container--J3fKI";
export var title = "hero-title-module--title--mkgxw";